export default __webpack_public_path__ + "static/secondary-08a8d5511ae2c0d871877e265bef48d6.jpg";